import { TextProps, Text } from "@radix-ui/themes";
import { styled } from "@stitches/react";
import { FieldError } from "react-hook-form";

type ErrorHintProps = TextProps & {
  error?: FieldError;
};

export const ErrorHint = ({ error, ...textProps }: ErrorHintProps) => (
  <Text
    as="label"
    size="1"
    color="red"
    className="error-hint"
    {...textProps}
    data-error={!!error}
  >
    {error?.message ?? "Required"}
  </Text>
);

export const Form = styled("form", {
  display: "flex",
  flexDirection: "column",
  gap: "var(--space-2)",
  fieldset: {
    border: "none",
    padding: 0,
    marginBottom: "var(--space-4)",
    position: "relative",
  },
  'label[data-required="true"]': {
    "&::after": {
      content: '"*"',
      color: "var(--red-11)",
    },
  },
  'label[data-optional="true"]': {
    "&::after": {
      content: '" (optional)"',
      color: "var(--gray-a11)",
      fontSize: "10px",
    },
  },
  "label.error-hint": {
    position: "absolute",
    visibility: "collapse",
    top: "100%",
    left: "0",
    marginTop: "3px",
    color: "var(--red-11)",
    pointerEvents: "none",
  },
  'label.error-hint[data-error="true"]': {
    visibility: "visible",
  },
});
